var map = {
	"./about-incocegla/Create.vue": "02e8",
	"./about-incocegla/Edit.vue": "47e2",
	"./about-incocegla/Form.vue": "c742",
	"./about-incocegla/List.vue": "fce33",
	"./about-incocegla/Show.vue": "4ab7",
	"./categories/Create.vue": "c04b",
	"./categories/Edit.vue": "f527",
	"./categories/Form.vue": "53e2",
	"./categories/List.vue": "b39c",
	"./categories/Show.vue": "cba8",
	"./clubs/Create.vue": "de8e",
	"./clubs/Edit.vue": "b40d",
	"./clubs/Form.vue": "28de",
	"./clubs/List.vue": "d942",
	"./clubs/Show.vue": "d4af",
	"./departments/Create.vue": "d96a",
	"./departments/Edit.vue": "c198",
	"./departments/Form.vue": "9cdc",
	"./departments/List.vue": "34be",
	"./departments/Show.vue": "f70c",
	"./doctors/Create.vue": "29be",
	"./doctors/Edit.vue": "7f86",
	"./doctors/Form.vue": "7162",
	"./doctors/List.vue": "c7d0",
	"./doctors/Show.vue": "02a5",
	"./events/Create.vue": "f235",
	"./events/Edit.vue": "92fe",
	"./events/Form.vue": "fe6c0",
	"./events/List.vue": "30cc",
	"./events/Show.vue": "1cc8",
	"./foundations/Create.vue": "9f64",
	"./foundations/Edit.vue": "8e55",
	"./foundations/Form.vue": "39c7",
	"./foundations/List.vue": "0e97",
	"./foundations/Show.vue": "e2be",
	"./general/Create.vue": "0f89",
	"./general/Edit.vue": "817f",
	"./general/Form.vue": "7bd5",
	"./general/List.vue": "2213",
	"./general/Show.vue": "d137",
	"./installations/Create.vue": "a512",
	"./installations/Edit.vue": "3054",
	"./installations/Form.vue": "814e",
	"./installations/List.vue": "dc27",
	"./installations/Show.vue": "8b20",
	"./medical-insurances/Create.vue": "b4c5",
	"./medical-insurances/Edit.vue": "3ce8",
	"./medical-insurances/Form.vue": "c6cf",
	"./medical-insurances/List.vue": "725d",
	"./medical-insurances/Show.vue": "e4d7",
	"./news/Create.vue": "1029",
	"./news/Edit.vue": "096b",
	"./news/Form.vue": "d120",
	"./news/List.vue": "e034",
	"./news/Show.vue": "13a4",
	"./pathologies/Create.vue": "a23b",
	"./pathologies/Edit.vue": "653e",
	"./pathologies/Form.vue": "33ec",
	"./pathologies/List.vue": "2744",
	"./pathologies/Show.vue": "0ad4",
	"./proyects/Create.vue": "e81a",
	"./proyects/Edit.vue": "03fe",
	"./proyects/Form.vue": "cb24",
	"./proyects/List.vue": "570d",
	"./proyects/Show.vue": "3fe1",
	"./sliders/Create.vue": "f70e",
	"./sliders/Edit.vue": "f4d3",
	"./sliders/Form.vue": "48af",
	"./sliders/List.vue": "3536",
	"./sliders/Show.vue": "99a8",
	"./specialties/Create.vue": "7e2f",
	"./specialties/Edit.vue": "9d5d",
	"./specialties/Form.vue": "8801",
	"./specialties/List.vue": "300c",
	"./specialties/Show.vue": "6dc4",
	"./testimonies/Create.vue": "3d61",
	"./testimonies/Edit.vue": "4e6d",
	"./testimonies/Form.vue": "e6f6",
	"./testimonies/List.vue": "f58c",
	"./testimonies/Show.vue": "e7a1",
	"./users/Form.vue": "9f05",
	"./users/List.vue": "c5d1",
	"./users/Show.vue": "7a48d",
	"./videos/Create.vue": "4394",
	"./videos/Edit.vue": "6364",
	"./videos/Form.vue": "4105",
	"./videos/List.vue": "8409",
	"./videos/Show.vue": "933c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a12";